import type {
  CalendarItemColor,
  RangePalette,
} from '@vk-hr-tek/ui/Calendar/types';

/**
 * Палитры оформления диапазонов календаря по цвету.
 */
export const RANGE_PALETTE: Record<CalendarItemColor, RangePalette> = {
  green: {
    bg: 'accent.bg.success',
    border: 'accent.text.success',
    text: 'accent.text.success',
  },
  purple: {
    bg: 'accent.bg.review',
    border: 'accent.text.review',
    text: 'accent.text.review',
  },
  red: {
    bg: 'accent.bg.error',
    border: 'accent.text.error',
    text: 'accent.text.error',
  },
  orange: {
    bg: 'accent.bg.warning',
    border: 'accent.text.warning',
    text: 'accent.text.warning',
  },
  blue: {
    bg: 'accent.bg.blue',
    border: 'accent.text.blue',
    text: 'accent.text.blue',
  },
  violet: {
    bg: 'bg.light.primary',
    border: 'accent.text.violet',
    text: 'accent.text.violet',
  },
  gray: {
    bg: 'bg.greyscale.primary',
    border: 'stroke.secondary',
    text: 'text.light.tertirary',
  },
  tertirary: {
    bg: 'bg.light.primary',
    border: 'stroke.tertirary',
    text: 'stroke.tertirary',
  },
};
